import React, { useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import { useBanners, useTiendaPrincipal } from '../storeData';
import useInstallPrompt from '../../hooks/useInstallPrompt';

export default function OptimizedNavbar() {
    const [isOpen, setIsOpen] = useState(false);
    const { tienda, loading: loadingTienda } = useTiendaPrincipal();
    const { data: banners, loading: loadingBanners } = useBanners();
    const installPrompt = useInstallPrompt();
    const bannerSeleccionado = banners?.find(banner => banner.seleccion === 'Si')?.imagen;

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    {tienda?.imagen1 ? (
                        <img src={tienda.imagen1} alt="logo" />
                    ) : (
                        <img src={logo} alt="logo" />
                    )}

                    <div className='deColumnNav'>
                        {tienda?.nombre ? (
                            <h2>{tienda.nombre}</h2>
                        ) : loadingTienda ? (
                            <span className='navTextSkeleton'></span>
                        ) : (
                            null
                        )}
                        {tienda?.eslogan ? (
                            <strong>{tienda.eslogan}</strong>
                        ) : loadingTienda ? (
                            <span className='navTextSkeleton navTextSkeletonSmall'></span>
                        ) : null}
                    </div>
                </Anchor>

                <div className='deFLexNavs'>
                    <InputSerach />
                    <Favoritos />
                    <div className={`nav_toggle ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loadingBanners ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <>
                                {bannerSeleccionado ? (
                                    <div className='fondo'>
                                        <img src={bannerSeleccionado} alt="Banner" />
                                    </div>
                                ) : (
                                    <div className='space'></div>
                                )}
                                <Profile installPrompt={installPrompt} />
                            </>
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
